import { AvailableTimeMap, AvailableTimeFirebase, AvailableTime } from './types';
import { getDayOfYear } from 'date-fns';

export const getAvailableTimeMapKey = (day: Date) => {
    return String(getDayOfYear(day)) + String(day.getFullYear());
};

export const convertToAvailableTimeMap = (
    availableTime?: Record<string, AvailableTimeFirebase | Exclude<AvailableTime, 'id'>>,
) => {
    if (!availableTime) return {};

    return Object.keys(availableTime).reduce((acc: AvailableTimeMap, cur: string) => {
        const date = availableTime[cur].date;
        const jsDate = date instanceof Date ? date : date.toDate();
        const mapKey = getAvailableTimeMapKey(jsDate);
        const deyOfYearData = { id: cur, time: availableTime[cur].time, date: jsDate };
        const availableTimeByDay = acc[mapKey] ? [...acc?.[mapKey], deyOfYearData] : [deyOfYearData];

        return {
            ...acc,
            [mapKey]: availableTimeByDay,
        } as AvailableTimeMap;
    }, {});
};
